"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listsEquivalent = exports.diffObjects = exports.objectsMatchDebug = exports.objectsMatch = void 0;
var iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "objectsMatch", { enumerable: true, get: function () { return iotv_v3_types_1.objectsMatch; } });
Object.defineProperty(exports, "objectsMatchDebug", { enumerable: true, get: function () { return iotv_v3_types_1.objectsMatchDebug; } });
Object.defineProperty(exports, "diffObjects", { enumerable: true, get: function () { return iotv_v3_types_1.diffObjects; } });
const listsEquivalent = (listone, listtwo, itemsMatchFn) => {
    if (listone.length !== listtwo.length)
        return false;
    for (const i in listone) {
        if (!listtwo.find((i2) => (itemsMatchFn ? itemsMatchFn(i, i2) : i === i2)))
            return false;
    }
    return true;
};
exports.listsEquivalent = listsEquivalent;
